import { useEffect, useState } from "react";
import { Alert, Container } from "@mui/material";

import { useUserContext } from "../../../contexts/userContext";


import Navigation from "../../header";
import PermissionGate from "../../permissionGate";
import Spinner from "../../spinner";

import "../../../styles/entity/appSettingList.scss";
import { AppConfig } from "../../../config/appConfig";
import { AppSetting } from "../../../types/appSetting";
import { AppSettingService } from "../../../services/appSettingService";
import AppSettingTable from "../../tables/appSettingTable";

const AppSettingList = () => {
	const userContext = useUserContext();
	const [gridView, setGridView] = useState<AppSetting[]>();
	const [isLoadingSettings, setIsLoadingSettings] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	const loadAppSettingsData = async () => {
		setIsLoadingSettings(true);
		setErrorMessage(undefined);

		AppSettingService.getAppSettings()
			.then((response) => {
				console.log('AppSettingsService.getAppSettings: SUCCESS', response);
				let appSettings = AppSettingService.mapAppSettings(response.data);
				setGridView(appSettings);
			})
			.catch((error) => {
				console.log('AppSettingsService.getAppSettings: ERROR', error);
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			})
			.finally(() => {
				setIsLoadingSettings(false);
			});
	}

	useEffect(() => {
		loadAppSettingsData();
	}, [])

	return (
		<div className="hwi-appSetting-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageApplicationSettings}>
					<section className="hwi-entity-search-bar">
						<div className="search-header">
							<div className="title">Applicaton Settings</div>
							<div></div>
						</div>
					</section>
					<Spinner dependency={isLoadingSettings} text="Loading Application Settings...">
						<section className="results">
							{errorMessage &&
								<Alert className="alert-error"
									severity="error">
									{errorMessage}
								</Alert>
							}
							{!errorMessage &&
								<AppSettingTable data={gridView}></AppSettingTable>
							}
						</section>
					</Spinner>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default AppSettingList;